import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { UrlEnum } from 'shared';
import { StatusBadge } from './StatusBadge';

export const ProgramHeaderCard = ({
    programId,
    programName,
    institutionName,
    status,
    statusType,
    teachOutPlan,
}) => (
    <div className="card p-3 mb-3">
        <a href={UrlEnum.SEARCH_ACADEMIC_AFFAIRS_PROGRAMS} className="d-inline-block mb-3">
            <FontAwesomeIcon icon={faArrowLeft} /> back to search
        </a>
        <div className="row">
            <div className="col-md">
                <label className="d-block text-muted">Program ID</label>
                <div>{programId}</div>
                <label className="d-block text-muted mt-3">Program Name</label>
                <h4>{programName}</h4>
                <label className="d-block text-muted">Institution</label>
                <div>{institutionName}</div>
            </div>
            <div className="col-md-auto border-left pl-4">
                <div className="mb-3">
                    <label className="d-block text-muted">Status</label>
                    <StatusBadge status={status} />
                </div>
                <div className="d-flex">
                    <div className="mr-4">
                        <label className="d-block text-muted">Status Type</label>
                        <div>{statusType}</div>
                    </div>
                    <div>
                        <label className="d-block text-muted">Teach-out Plan</label>
                        <div>{teachOutPlan}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
);
